module.exports = __webpack_public_path__ + "static/media/2B.ae15fb1b.svg";